import { useEffect, useState, type FunctionComponent } from 'react';
import { ZoomCallEnd as SharedZoomCallEnd } from '@qler-view/shared_lib/src/shared/zoom';
import {
  useGetZoomParticipantJoinedDetails,
  useUpdateConsultStatus,
} from '../../shared/zoom/zoomSetup';
import type { UpdateConsultStatusType } from '@qler-view/shared_lib/src/shared/zoom/zoomTypes';
import { useParams } from 'react-router';
import { Box } from '@mui/material';
import { CustomTypography } from '@qler-view/shared_lib/src';

export { getTimeDifference } from '@qler-view/shared_lib/src/shared/zoom';
import './zoomCall.css';

const ZoomCallEnd: FunctionComponent = () => {
  const userId = Number.parseInt(localStorage.getItem('userId') ?? '0');
  const { caseId } = useParams<{
    meetingId: string;
    caseId: string;
  }>();
  const [isCompleted, setIsCompleted] = useState(false);
  const [shouldPoll, setShouldPoll] = useState(true);

  const { zoomParticipant } = useGetZoomParticipantJoinedDetails(
    Number(caseId),
    shouldPoll
  );

  const onSuccess = () => {
    setIsCompleted(true);
  };

  const { mutate: updateConsultStatus } = useUpdateConsultStatus(
    onSuccess,
    userId
  );

  useEffect(() => {
    if (!zoomParticipant) return;

    if (zoomParticipant.timedOut === false) {
      setShouldPoll(false);

      const payload: UpdateConsultStatusType = {
        consultId: Number(caseId),
        sessionStatus: 'Call Completed',
        participantJoined: zoomParticipant.participantJoined,
        callCompletedFrom: 'zoom',
      };

      updateConsultStatus(payload);
    }
  }, [zoomParticipant, caseId]);

  if (zoomParticipant?.timedOut) {
    return (
      <Box className="zoom-circular-progress">
        <CustomTypography
          id="loading-text"
          variant="h5"
          className="text-align-center pt-32"
          color="textDisabled"
        >
          Zoom call is ending. Please wait...
        </CustomTypography>
      </Box>
    );
  }

  if (isCompleted) {
    return <SharedZoomCallEnd />;
  }

  return (
    <Box className="zoom-circular-progress">
      <CustomTypography
        id="loading-text"
        variant="h5"
        className="text-align-center pt-32"
        color="textDisabled"
      >
        Zoom call is ending. Please wait...
      </CustomTypography>
    </Box>
  );
};

export default ZoomCallEnd;
